import { render, staticRenderFns } from "./ConsentimientoFotografias.vue?vue&type=template&id=56dd7d76&"
import script from "./ConsentimientoFotografias.vue?vue&type=script&lang=js&"
export * from "./ConsentimientoFotografias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports